<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("CHAIN_TRAVEL_AGENT_INFOMATION") }} - {{ $t("CHAIN") }}</h4>
    </div>
    <v-progress-linear
      color="warning"
      indeterminate
      rounded
      height="3"
      v-if="isLoading"
    ></v-progress-linear>
    <v-form ref="form" lazy-validation v-on:submit.prevent v-if="!isLoading">
      <v-spacer />
      <div class="grid-body p-3 border-top-unset mb-4">
        <v-card class="h-100 border p-3 mb-3" elevation="0">
          <label class="label-title mb-2">{{ $t("CHAIN_TRAVEL_AGENT_INFOMATION") }}</label>
          <div class="d-flex">
            <div class="pl-2 w-30">
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("TA_NAME")
                }} 1</span>
                <span class="booking-detail-content">
                  {{ data.nameVi }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("TA_CODE")
                }} 2</span>
                <span class="booking-detail-content">
                  {{ data.travelAgentCode }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("DESCRIPTION")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.noteVi }} 
                </span>
              </div>
            </div>
            <div class="pl-5">
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("_CONTRACT.TAX_CODE")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.taxCode }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("ENTERPRISE_CODE")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.enterpriseCode }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("ADDRESS")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.addressVi }}{{ data.cityVi ? ", " +  data.cityVi : ""}}{{ data.countryCode3 && locations.find(e => e.id === data.countryCode3) ? ", " +  locations.find(e => e.id === data.countryCode3).label : "" }}
                </span>
              </div>
            </div>
          </div>
        </v-card>
        <v-card class="h-100 border p-3 mb-3" elevation="0">
          <label class="label-title mb-2">{{ $t("_BOOKING_DETAIL.CONTACT.TITLE") }}</label>
          <div v-for="(contact, index) in data.travelAgentContacts" :key="index">
            <div class="d-flex justify-">
              <div class="pl-2 w-30">
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("FIRST_NAME_REPRESENT")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.firstName }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("LAST_NAME_REPRESENT")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.lastName }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("POSITION")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.position }} 
                  </span>
                </div>
              </div>
              <div class="pl-5">
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("_EDIT_USER.PHONE_NUMBER")
                  }} 1</span>
                  <span class="booking-detail-content">
                    {{ contact.phone }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("_EDIT_USER.PHONE_NUMBER")
                  }} 2</span>
                  <span class="booking-detail-content">
                    {{ contact.mobile }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("Email")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.email }}
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("ADDRESS")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.address }}
                  </span>
                </div>
              </div>

            </div>
            <v-divider v-if="index < 2 - 1" />
          </div>
        </v-card>
        <v-card class="h-100 border p-3 mb-3" elevation="0">
          <label class="label-title mb-3">{{ $t("INFOMATION_OF_BANK_ACCOUNT") }}</label>
          <div class="pl-2 ">
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("_CONTRACT.BANK_ACCOUNT")
              }}</span>
              <span class="booking-detail-content">
                {{ data.bankAccount }} 
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("ACCOUNT_HOLDER")
              }}</span>
              <span class="booking-detail-content">
                {{ data.accountHolder }} 
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("_CONTRACT.BANK")
              }}</span>
              <span class="booking-detail-content">
                {{ data.bank }}
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("_CONTRACT.BANK_BRANCH")
              }}</span>
              <span class="booking-detail-content">
                {{ data.bankBranch }}
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">Swift Code</span>
              <span class="booking-detail-content">
                {{ data.swiftCode }}
              </span>
            </div>
          </div>
        </v-card>
        
        <v-divider />
        <label class="label-title">{{ $t("ASSIGN_TA_TO_HOTEL") }}</label>
        <v-row>
          <v-col sm="3">
            <v-card style="min-height: 350px">
              <v-card-title class="fs-12 text-uppercase">{{ $t("UNASSIGN") }}</v-card-title>
              <div class="pl-2 pr-2">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  :placeholder="$t('HOTEL_NAME')"
                  v-model="searchUnApply"
                  @input="searchOnUnApply"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <v-list class="mt-2" flat subheader three-line>
                <v-list-item-group
                  v-model="unApplySetting"
                  multiple
                  active-class="grey lighten-3"
                  style="max-height: 230px; overflow: auto"
                >
                  <template v-for="(item, index) in searchedUnApply">
                    <v-list-item :key="index">
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.name"
                            :class="!active ? 'text-secondary' : ''"
                          >
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
            <p class="mb-0 mt-2">
              {{ searchedUnApply.length }}/{{ unApplyHotel.length }}
              {{ $t("ITEMS_SHOWING") }}
            </p>
          </v-col>
          <v-col sm="1" class="d-flex align-center justify-content-center">
            <div>
              <v-btn class="d-block" @click="leftToRight">
                <v-icon>navigate_next</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="rightToLeft">
                <v-icon>chevron_left</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="allLeftToRight">
                <v-icon>keyboard_double_arrow_right</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="allRightToLeft">
                <v-icon>keyboard_double_arrow_left</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="compare">
                <v-icon>compare_arrows</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col sm="3">
            <v-card style="min-height: 350px">
              <v-card-title class="fs-12 text-uppercase">{{ $t("ASSIGN") }}</v-card-title>
              <div class="pl-2 pr-2">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  :placeholder="$t('HOTEL_NAME')"
                  v-model="searchApply"
                  @input="searchOnApply"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <v-list class="mt-2" flat subheader three-line>
                <v-list-item-group
                  v-model="applySetting"
                  multiple
                  active-class="grey lighten-3"
                  style="max-height: 230px; overflow: auto"
                >
                  <template v-for="(item, index) in searchedApply">
                    <v-list-item>
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.name"
                            :class="!active ? 'text-secondary' : ''"
                          >
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
            <p class="mb-0 mt-2">
              {{ searchedApply.length }}/{{ applyHotel.length }} {{ $t("ITEMS_SHOWING") }}
            </p>
          </v-col>
        </v-row>
        <b-row>
          <v-col>
            <v-checkbox
              v-model="data.autoApply"
              :label="$t('ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL')"
              class="mt-0"
            ></v-checkbox>
          </v-col>
          <v-col>
            <div class="btn-bottom">
              <v-btn depressed class="mr-5" @click="back">{{ $t("BACK") }}</v-btn>
              <v-btn color="primary" class="pl-10 pr-10" @click="save">{{
                $t("SAVE")
              }}</v-btn>
            </div>
          </v-col>
        </b-row>
      </div>
    </v-form>
  </div>
</template>
<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}
</style>
<script>
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.name).includes(toLower(term)));
  }

  return items;
};
import store from "@/plugins/store";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import { systemService } from "@/_services/system-data.service.js";

import { _alert } from "@/_helpers/function.js";

export default {
  components: {},
  props: {
    nextTab: Function,
  },
  created() {
    this.initialize();
  },
  mounted() {},
  data() {
    return {
      data: {
        travelAgentCode: "",
        nameVi: "",
        email: "",
        swiftCode: null,
        website: null,
        bank: "",
        bankAccount: "",
        taxCode: "",
        addressVi: "",
        mobile: null,
        phone: "",
        fax: "",
        cityVi: "",
        countryCode3: "VN",
        enterpriseCode: "",
        firstName: "",
        lastName: "",
        noteVi: "",
        applyHotel: [],
        autoApply: false,
        id: "",
        accountHolder: null,
        position: null,
      },
      isEdit: false,
      applySetting: [],
      unApplySetting: [],
      isLoading: true,
      systemLang: this.$i18n.locale,
      hotelchain: [],
      applyHotel: [],
      unApplyHotel: [],
      searchApply: null,
      searchedApply: [],
      searchedUnApply: [],
      locations: [],
      sectionConfigs: {
        default: {
          limit: 4,
          ulClass: { "data-darren": true },
          liClass: { "elf-row": true },
        },
        Elf: {
          limit: 6,
        },
      },
      suggestion: [],
    };
  },
  computed: {},
  watch: {
    tab(value) {
      this.langTab = value ? "en" : "vi";
    },
    listOtpsBed: {
      handler(value) {},
      deep: true,
    },
  },
  methods: {
    mapCity(data) {
      this.data.cityVi = data.item
    },
    clearSearch() {
      this.searchApply = null;
      this.searchUnApply = null;
      this.searchOnApply();
      this.searchOnUnApply();
    },
    searchOnApply() {
      this.searchedApply = searchByName(this.applyHotel, this.searchApply);
    },
    searchOnUnApply() {
      this.searchedUnApply = searchByName(this.unApplyHotel, this.searchUnApply);
    },
    leftToRight() {
      if (this.unApplySetting.length > 0) {
        this.unApplySetting.forEach((e) => {
          this.applyHotel.push(this.searchedUnApply[e]);
        });
        this.unApplyHotel = this.hotelchain.filter(
          (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
        );
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },

    rightToLeft() {
      if (this.applySetting.length > 0) {
        this.applySetting.forEach((e) => {
          this.unApplyHotel.push(this.searchedApply[e]);
        });
        this.applyHotel = this.hotelchain.filter(
          (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
        );
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    allLeftToRight() {
      if (this.searchedUnApply.length > 0) {
        this.searchedUnApply.forEach((e) => {
          this.applyHotel.push(e);
        });
        this.unApplyHotel = this.hotelchain.filter(
          (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
        );
        this.searchedUnApply = [];
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    allRightToLeft() {
      if (this.searchedApply.length > 0) {
        this.searchedApply.forEach((e) => {
          this.unApplyHotel.push(e);
        });
        this.applyHotel = this.hotelchain.filter(
          (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
        );
        this.searchedApply = [];
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    compare() {
      const apply = Array.from(new Set(this.applyHotel.map(JSON.stringify))).map(
        JSON.parse
      );
      const unApply = Array.from(new Set(this.unApplyHotel.map(JSON.stringify))).map(
        JSON.parse
      );
      this.applyHotel = [...unApply];
      this.unApplyHotel = [...apply];
      this.applySetting = [];
      this.unApplySetting = [];
      this.clearSearch();
    },
    async getHotelByChain() {
      await chainService.getHotelByChain(this.defaultI18n).then((res) => {
        if (res.responseCode == 0) {
          this.hotelchain = res.data;
          if (this.data.applyHotel.length > 0) {
            this.applyHotel = this.hotelchain.filter((e) =>
              this.data.applyHotel.includes(e.id)
            );
            this.unApplyHotel = this.hotelchain.filter(
              (e) => !this.data.applyHotel.includes(e.id)
            );

            this.searchedApply = this.hotelchain.filter((e) =>
              this.data.applyHotel.includes(e.id)
            );
            this.searchedUnApply = this.hotelchain.filter(
              (e) => !this.data.applyHotel.includes(e.id)
            );
          } else {
            this.unApplyHotel = [...this.hotelchain];
            this.clearSearch();
          }
          this.getLocation();
        }
      });
    },
    async getLocation() {
      await chainService.getCountry(this.defaultI18n).then((res) => {
        this.locations = res.data.map((x) => {
          return {
            id: x.code,
            label: x.title,
          };
        });
        this.getSuggestion();
        // this.country = this.select.countries[0].id;
        this.isLoading = false;
      });
    },
    async getSuggestion() {
      await systemService.getLocations().then((res) => {
        this.suggestion = res.data.map((x) => {
          return {
            locType: x.locType,
            name: x.i18ns.find((x) => x.lang == this.defaultI18n).name,
          };
        });
      });
    },

    async initialize() {
      // _resetErrorState(this.ferrors);
      let id = this.$route.params.id;
      if (id != "00000000-0000-0000-0000-000000000000") {
        chainService.getChainTravelAgentInfo(id).then((res) => {
          if (res.responseCode == 0) {
            this.data = res.data;
            this.isEdit = true;
            this.getHotelByChain();
          }
        });
      } else {
        this.getHotelByChain();
        this.isEdit = false;
      }
    },
    back() {
      this.$router.push({ name: "ChainAgent" });
    },
    clickSelectAllChannel() {
      // this.data.channels = [];
      if (this.selectAllChannel) {
        this.listOfChannels.forEach((e) => {
          this.data.channels.push(e.id);
        });
      } else {
        this.data.channels = [];
      }
    },
    clickSelectAllMarket() {
      // this.data.markets = [];
      if (this.selectAllMarket) {
        this.listOfMarkets.forEach((e) => {
          this.data.markets.push(e.id);
        });
      } else {
        this.data.markets = [];
      }
    },
    save() {
      let form_validate = this.$refs.form.validate();

      if (!form_validate) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false,
        });
        const el = document.querySelector(".v-messages.error--text:first-of-type");
        el.scrollIntoView();
        return false;
      }

      let updatedData = Object.assign({}, this.data);
      updatedData.travelAgentCode =  updatedData.travelAgentCode.toUpperCase();
      updatedData.applyHotel = this.applyHotel
        .filter((e) => this.data.applyHotel.includes(e.id))
        .map((item) => item.id);
      updatedData.unApplyHotel = this.data.applyHotel.filter(
        (e) => !this.applyHotel.map((item) => item.id).includes(e)
      );
      updatedData.creatApplyHotel = this.applyHotel
        .filter((e) => !this.data.applyHotel.includes(e.id))
        .map((item) => item.id);
      if (this.isEdit) {
        chainService.updateAgent(updatedData).then((res) => {
          _alert(res, this.$t(res.data));
        });
      } else {
        delete updatedData.id;
        chainService.createAgent(updatedData).then((res) => {
          if (res.responseCode === 0) {
            _alert(res, this.$t(res.data), false);
            this.$router.push({
              name: "ChainAgent",
            });
          } else {
            _alert(res, this.$t(res.data), false);
          }
        });
      }
    },
  },
};
</script>
